import React from "react";
import TypeIconReturner from "../TypeIconReturner/TypeIconReturner";
import { getSoapOperaScheduleLabel } from "../../shared/constants/soapOperaSchedule";

const SingleValue = ({ innerRef, innerProps, isFocused, ...props }) => {
  return (
    <div className="singleValue" ref={innerRef} {...innerProps}>
      <div className="singleValueInfo">
        <div className="contentName">
          <TypeIconReturner type={props.data.type} responsiveIcon />

          <span className="singleValueName">{props.data.label}</span>
        </div>

        <div className="creators">

          {props.data.type !== "Research" &&
            <>
              {!!props.data.creators.length
                ? props.data.creators.map((creator, index) => {
                    return (
                      <div className="creator" key={index}>
                        <span>{creator.name}</span>
                        {index + 1 < props.data.creators.length && (
                          <span className="separator">|</span>
                        )}
                      </div>
                    );
                  })
                : "-"
              }
            </>
          }
          
          {props.data.type === "Research" && 
          !!props.data.researchers.length &&
            props.data.researchers.map((researcher, index) => {
              return (
                <div className="researcher" key={index}>
                  <span>{researcher.name}</span>
                  {index + 1 < props.data.researchers.length && (
                    <span className="separator">|</span>
                  )}
                </div>
              );
            })}
        </div>

        <span className="type">
          {props.data.type === "Research"
            ? null
            : props.data.format?.name === "Novela"
            ? `${props.data.format.name} • ${getSoapOperaScheduleLabel(
                props.data.soapOperaSchedule
              )}`
            : props.data.format?.name}
        </span>
      </div>
    </div>
  );
};

export default SingleValue;
